<template>
    <div class="tag-list">
        <div class="tag-list-header">Tags</div>
        <div class="tag-list-tags">
            <div v-for="(tags, logicalGroup) in data" :key="logicalGroup">
                <div class="tag-list-group">{{ logicalGroup }}</div>
                <div class="tag-list-group-tags">
                    <div v-for="tag in tags" :key="tag" class="tag-list-item-container">
                        <router-link :to="{ path: '/structures', query: { tag: tag } }" class="tag-list-tag">
                            {{ tag }}
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
.tag-list {
    border: 1px solid #ccc;
    border-radius: 5px;
    padding: 10px;
}

.tag-list-item-container {
    padding-right: 5px;
    padding-bottom: 15px;
}

.tag-list-header {
    font-size: 1.2rem;
    font-weight: bold;
    margin-bottom: 10px;
}

.tag-list-group {
    font-weight: bold;
    margin-bottom: 5px;
}

.tag-list-group-tags {
    display: flex;
    flex-wrap: wrap;
}

.tag-list-tag {
    margin-right: 5px;
    margin-bottom: 5px;
    padding: 5px 10px;
    background-color: #eee;
    border-radius: 20px;
    text-decoration: none;
    color: #333;
}

.tag-list-tag:hover {
    background-color: #ddd;
}
</style>

<script>
export default {
    props: {
        data: {
            type: Object,
            required: true
        }
    }
}
</script>
